import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

const httpOptions =
{
	headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
	providedIn: 'root'
})
export class AjaxService 
{

	constructor(
		private http: HttpClient,
		private router: Router,
		private configService: ConfigService,
	) { }

	getData(url: string) 
	{
		const startTime = performance.now(); // Start timing

		return this.http.get(url).pipe(
			tap({
				next: (response) => {
					const elapsedTime = performance.now() - startTime; // Calculate elapsed time
					console.log("Ajax good >> ", response)
				},
				error: (error) => {
					const elapsedTime = performance.now() - startTime; // Calculate elapsed time
					console.error("Ajax bad << ", error)
				},
			})
		);
	}

	updateData(url: string, data: any, userId: number) 
	{
		url = url + data + '/' + userId;
		return this.http.put(url, data, httpOptions)
	}

	updateObjectData(url: string, data: any) 
	{
		return this.http.put(url, data, httpOptions)
	}

	addData(url: string, data: any, userId: number) 
	{
		url = url + data + '/' + userId;
		//this.logServ.log(AjaxService.name, 'addData - post', `url: ${url}, data: ${JSON.stringify(data)}, userId: ${userId}`);
		return this.http.post(url, data, httpOptions);
	}

	addObjectData(url: string, data: any) 
	{
		return this.http.post(url, data, httpOptions);
	}

	_throwError(err: any): void 
	{
		if (err.status === 0) 
		{
			console.error("Error on Ajax, code 0")
			this.router.navigate(['/error', { code: err.status }]);
		}
		if (err.status === 500) 
		{
			console.error("Error on Ajax, code 500")
			this.router.navigate(['/error', { code: err.status }]);
		}
	}

	public getBaseOfApi() 
	{
		return this.configService.getApiEndPoint();
	}

	// >>>>>>>>> Example of Olga
	// login(baseUrl: string, lng: string, user: string | any, pass: string | any) {
	//   //this.logServ.log(AjaxService.name, 'login - baseUrl+lng+user+pass', baseUrl + ', ' + lng + ', ' + user + + ', ' + pass);
	//   let data = { lang: lng, user: user, pass: pass };
	//   const url = baseUrl + '/api/login/' + data;
	//   this.logServ.log(AjaxService.name, 'login url', baseUrl + '/api/login/' + JSON.stringify(data));
	//   return this.http.put(url, data, httpOptions);
	// }

	// Example of a minimal LogService for context if you don't have one
	// In a real app, this would be in its own file (e.g., log.service.ts)
	// @Injectable({ providedIn: 'root' })
	// class LogService {
	//   log(source: string, method: string, message: string, data?: any): void {
	//     console.log(`[${source}:${method}] ${message}`, data || '');
	//   }
	//   logWithoutData(source: string, message: string): void {
	//     console.log(`[${source}] ${message}`);
	//   }
	// }
}
